import { isSameDay, isSameMonth, isSameYear } from 'date-fns'

export default (dateLeft: Date | null, dateRight: Date | null) =>
  isSameDay(dateLeft, dateRight) &&
  isSameMonth(dateLeft, dateRight) &&
  isSameYear(dateLeft, dateRight)
